import DropdownMenu, { DropdownMenuItem, Line } from './DropdownMenu'

DropdownMenu.Item = DropdownMenuItem
DropdownMenu.Line = Line

export default DropdownMenu
